import { createDynamicSlice } from ".";
import {
  ReturnAcceptThunk,
  ReturnBarThunk,
  ReturnChangeStatusThunk,
  ReturnDetailThunk,
  ReturnShipmentThunk,
  ReturnThunk,
} from "../thunks/returnThunk";

const ReturnSlice = createDynamicSlice({
  name: "ReturnSlice",
  thunk: ReturnThunk,
  listMode: true,
});

const ReturnDetailSlice = createDynamicSlice({
  name: "ReturnDetailSlice",
  thunk: ReturnDetailThunk,
});

const ReturnBarSlice = createDynamicSlice({
  name: "ReturnBarSlice",
  thunk: ReturnBarThunk,
});

const ReturnShipmentSlice = createDynamicSlice({
  name: "ReturnShipmentSlice",
  thunk: ReturnShipmentThunk,
});

const ReturnChangeStatusSlice = createDynamicSlice({
  name: "ReturnChangeStatusSlice",
  thunk: ReturnChangeStatusThunk,
  resetActionName: "resetChangeStatus",
});

const ReturnAcceptSlice = createDynamicSlice({
  name: "ReturnAcceptSlice",
  thunk: ReturnAcceptThunk,
  resetActionName: "resetAcceptReturn",
});

export const returnReducer = ReturnSlice.reducer;
export const returnDetailReducer = ReturnDetailSlice.reducer;
export const returnBarReducer = ReturnBarSlice.reducer;
export const returnShipmentReducer = ReturnShipmentSlice.reducer;
export const changeReturnStatusReducer = ReturnChangeStatusSlice.reducer;
export const acceptReturnReducer = ReturnAcceptSlice.reducer;

export const { resetChangeStatus } = ReturnChangeStatusSlice.actions;
// export const { resetApproveRefund } = ApproveRefundSlice.actions;
export const { resetAcceptReturn } = ReturnAcceptSlice.actions;
